import { render, staticRenderFns } from "./EmailSubscription.vue?vue&type=template&id=c42e9972&"
import script from "./EmailSubscription.vue?vue&type=script&lang=js&"
export * from "./EmailSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports